import React, { useState } from 'react';
import classes from './ExpansionPanel.module.scss';
import ArrownDownSvg from '../../assets/svg/ArrowDown';
import useUser from '../../utils/hooks/useUser';
import ArrownDownSvgIcon from '../../assets/svg/ArrowDownSvg';
import ArrownUpSvgIcon from '../../assets/svg/ArrowUpSvg';

const ExpansionPanel = ({
  summaryContainerClassName,
  detailContainerClassName,
  mainContainerClassName,
  children,
  title,
  type,
  src,
  icon,
  target,
  amount,
  typeColor,
  hideSummary,
}: any) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const { isGM } = useUser();

  const closePanel = () => {
    setIsCollapsed(true);
  };
  let summaryContainerClass = classes.summary_container;
  let detailContainerClass = classes.detail_container;
  let mainClass = classes.main;
  if (mainContainerClassName) {
    mainClass = `${mainClass} ${mainContainerClassName}`;
  }
  if (summaryContainerClassName) {
    summaryContainerClass = `${summaryContainerClass} ${summaryContainerClassName}`;
  }
  if (detailContainerClassName) {
    detailContainerClass = `${detailContainerClass} ${detailContainerClassName}`;
  }
  return (
    <div
      className={mainClass}
      onClick={(e: any) => {
        console.log('e.target.className', e.target.className);
        const isSummaryClicked =
          e.target.className.includes('ExpansionPanel_summary') ||
          e.target.className.includes('ExpansionPanel_title') ||
          e.target.className.includes('ExpansionPanel_amount_value');
        if (isSummaryClicked) {
          setIsCollapsed(!isCollapsed);
          if (isCollapsed) {
            hideSummary();
          }
        }
      }}
    >
      <div className={summaryContainerClass}>
        <div className={classes.section_left}>
          {icon && (
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setIsCollapsed(!isCollapsed);
              }}
            >
              {icon}
            </div>
          )}
          <div className={classes.title_container}>
            <div className={classes.title}>{title}</div>
            <div className={classes.title} style={{ color: typeColor }}>
              {type}
            </div>
            {!isGM && (
              <div className={classes.title} style={{ color: typeColor }}>
                Sales Target
              </div>
            )}
          </div>
        </div>
        <div className={classes.section_right}>
          <div className={classes.amount_container}>
            <div className={classes.empty_div}></div>
            {!isGM && <div className={classes.amount_value}>{target}</div>}
            <div className={classes.amount_value}>{amount}</div>
          </div>
          <div
            className={classes.icon_container}
            onClick={() => {
              setIsCollapsed(!isCollapsed);
            }}
          >
            {isCollapsed ? <ArrownDownSvgIcon /> : <ArrownUpSvgIcon />}
          </div>
        </div>
      </div>
      {!isCollapsed && children && (
        <div className={detailContainerClass}>{children(closePanel)}</div>
      )}
    </div>
  );
};

export default ExpansionPanel;
